import React from "react";
import { useTranslation } from "react-i18next";
import {
  ChecklistSmallIcon,
  DependencySmallIcon,
  MessageSmallIcon,
  RecurringCheckmarkSmallIcon,
  Signifier,
} from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import HiddenFromClients from "~/components/tasks/Signifiers/HiddenFromClients";

export const TaskSignifiers = ({
  subtasks,
  comments,
  dependencies,
  hiddenFromClients,
  taskHiddenFromClient,
  fromRecurring,
  className,
}) => {
  const { t } = useTranslation();

  const subtaskText = t("Subtasks");
  const commentsText = t("Comments");
  const dependenciesText = t("Dependencies");
  const recurringText = t("Made from recurring task");

  return (
    <span
      className={classNames("task_signifiers", className)}
      data-testid="task-signifiers"
    >
      {subtasks > 0 && (
        <Signifier
          type={ChecklistSmallIcon}
          value={subtasks}
          tooltipText={subtaskText}
        />
      )}
      {comments > 0 && (
        <Signifier
          type={MessageSmallIcon}
          value={comments}
          tooltipText={commentsText}
        />
      )}
      {dependencies > 0 && (
        <Signifier
          type={DependencySmallIcon}
          value={dependencies}
          tooltipText={dependenciesText}
        />
      )}
      {hiddenFromClients && (
        <HiddenFromClients
          hiddenFromClients={taskHiddenFromClient}
          small
        />
      )}
      {fromRecurring && (
        <Signifier
          type={RecurringCheckmarkSmallIcon}
          tooltipText={recurringText}
        />
      )}
    </span>
  );
};

TaskSignifiers.propTypes = {
  subtasks: PropTypes.number,
  comments: PropTypes.number,
  dependencies: PropTypes.number,
  hiddenFromClients: PropTypes.bool,
  taskHiddenFromClient: PropTypes.bool,
  fromRecurring: PropTypes.bool,
  className: PropTypes.string,
};

TaskSignifiers.defaultProps = {
  subtasks: 0,
  comments: 0,
  dependencies: 0,
  hiddenFromClients: false,
  taskHiddenFromClient: false,
  fromRecurring: false,
};
